const FacilityTabs = ({ tabs, activeTab, onChange }) => (
  <div className="mb-5 flex flex-wrap gap-1 rounded-2xl border border-gray-100 bg-white p-2">
    {tabs.map((tab) => (
      <button
        key={tab.key}
        type="button"
        onClick={() => onChange(tab.key)}
        className={`flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-semibold transition-colors ${
          activeTab === tab.key ? "bg-[#2B3674] text-white" : "text-gray-600 hover:bg-gray-50"
        }`}
      >
        {tab.label}
        {tab.count != null && (
          <span
            className={`rounded-full px-2 py-0.5 text-xs font-semibold ${
              activeTab === tab.key ? "bg-white/20 text-white" : "bg-gray-100 text-gray-500"
            }`}
          >
            {tab.count}
          </span>
        )}
      </button>
    ))}
  </div>
);

export default FacilityTabs;
